export type PhysicalTrayQuantityResult =
  | { pieces: string; error: null }
  | { pieces: null; error: string };

/** Exact decimal-text conversion; capacity always comes from server metadata. */
export function resolvePhysicalTrayQuantity(
  text: string,
  capacity: number | null | undefined,
): PhysicalTrayQuantityResult {
  const match = /^(\d+)(?:\.(\d*))?$/.exec(text.trim());
  if (!match) return { pieces: null, error: "Enter a positive decimal quantity." };
  const fraction = (match[2] ?? "").replace(/0+$/, "");
  if (fraction.length > 4) {
    return { pieces: null, error: "Use at most four decimal places." };
  }
  // Bound text before constructing BigInts, matching numeric(18,4).
  const whole = match[1].replace(/^0+/, "") || "0";
  if (whole.length > 14) return { pieces: null, error: "Quantity exceeds the supported range." };
  const scale = 10n ** BigInt(fraction.length);
  const quantity = BigInt(whole) * scale + BigInt(fraction || "0");
  if (quantity <= 0n) return { pieces: null, error: "Quantity must be greater than zero." };
  if (capacity == null || !Number.isSafeInteger(capacity) || capacity <= 0) {
    return { pieces: null, error: "Select pricing with a configured tray capacity." };
  }
  const product = quantity * BigInt(capacity);
  if (product % scale !== 0n) {
    return { pieces: null, error: "This quantity would produce a partial seedling." };
  }
  return { pieces: (product / scale).toString(), error: null };
}
